import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WholesalerCatalogService {
  constructor(private http: HttpClient) {}

  public get(params = null): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/catalog`,
      { params },
    );
  }

  public getSingleItem(id, params = null): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/analytica/catalog/${id}`,
      { params },
    );
  }
}
